import { Component, Input } from '@angular/core';
import { DisplayService } from 'src/app/services/display.service';

@Component({
  selector: 'app-show-single-image',
  standalone: true,
  templateUrl: './show-single-image.component.html',
  styleUrls: ['./show-single-image.component.css']
})
export class ShowSingleImageComponent {
  constructor(public displayService: DisplayService) { }

  @Input() imageURL: string | null = null;

}